export const commonHelpers = {
    isWebView: () => {
        const standalone = window.navigator.standalone;
        const userAgent = window.navigator.userAgent.toLowerCase();
        const safari = /safari/.test(userAgent);
        const ios = /iphone|ipod|ipad/.test(userAgent);

        return ios ? !standalone && !safari : userAgent.includes('wv');
    },
    isIframe: () => {
        return window !== window.parent;
    }
}
